import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

/*Actions*/
import {
	getDocuments
} from '../../../../redux/actions';

class MapGuidelines extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: ''
		}
	}

	componentWillMount() {
		if (!this.props.isAccessToMAPGuidelines) {
			browserHistory.push('/home');
		}
	}

	componentDidMount() {
		const { resources } = this.props.state;
		const self = this;
		self.setState({
			errorMessage: ''
		})
		if(!resources.documents) {
			// second param says whether it needs to be saved into store
			self.props.getDocuments('requestType=mapGuideLines', true, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					})
				}
			});
		}
	}
	handleGetHelpDocuments(docId, fileExtension, docName, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			errorMessage: ''
		});

		// second param says whether it needs to be saved into store
		self.props.getDocuments(`requestType=mapGuideLines&docId=${docId}&docName=${docName}&docType=${fileExtension}`, false, response => {
			if(!response.status) {
				self.setState({
					errorMessage: 'Error occured while fetching documents.'
				})
			} else {
				window.open(response.responseObject, '_blank');
			}
		});
	}

    render() {
		const { resources } = this.props.state;
		let documents = null;
		if(resources.documents && resources.documents.responseObject) {
			documents = JSON.parse(JSON.stringify(resources.documents.responseObject.filter(itm => itm.fileExtension === 'pdf' || itm.fileExtension === 'xlsx'|| itm.fileExtension === 'xls')));
		}
	    return (
			<div>
		        <h1 className="pageTitle" style={{margin: '21px 0'}}>Minimum Advertised Price (MAP) Guidelines</h1>
				<p className="bold red">{this.state.errorMessage}</p>
		        <div className="searchResults">
					<table className="dataTable" width="70%">
						<thead>
							<tr>
								<th>Document</th>
								<th>Effective&nbsp;Date</th>
							</tr>
						</thead>
			            <tbody>
							{documents && documents.length > 0 && documents.map((item, index) => {
								return <tr key={index}>
			  	                	<td><a href="" onClick={this.handleGetHelpDocuments.bind(this, item.docId, item.fileExtension, item.docName)}>{item.docTitle}</a></td>
			  	                	<td>{item.effectiveDate}</td>
			  	              	</tr>
							})}
							{documents && documents.length === 0
								?<tr><td colSpan={2}>No records found.</td></tr>
								:null
							}
						</tbody>
					</table>
		          	<div className="clear" />
				</div>
			</div>
	    );
  	}
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
});

MapGuidelines = connect(mapStateToProps, mapDispatchToProps)(MapGuidelines);
export default MapGuidelines;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/MapGuidelines/index.js